module.exports = __webpack_public_path__ + "static/img/9.24a73f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/9.png
// module id = 9WA3
// module chunks = 0